module.exports = __webpack_public_path__ + "static/media/secondpicture.aac1c3ba.png";